// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-21b46ab6] .p-picklist-source-controls,[data-v-21b46ab6] .p-picklist-target-controls{display:none}[data-v-21b46ab6] .p-button .p-badge{min-width:1.5em;height:1.5em;line-height:1.5em;font-size:1em}", ""]);
// Exports
module.exports = exports;
